module.exports = __webpack_public_path__ + "img/bell.a9587939.png";